// hooks/useIdleTimer.ts
import { useEffect, useState, useRef, MutableRefObject } from "react";

interface IdleTimerProps {
  timeout?: number;       
  warningTime?: number;   
  onTimeout: () => void;  
}

export const useIdleTimer = ({
  timeout = 2 * 60 * 1000,   
  warningTime = 1 * 60 * 1000, 
  onTimeout,
}: IdleTimerProps) => {
  const [isWarningVisible, setIsWarningVisible] = useState<boolean>(false);
  const timerRef: MutableRefObject<NodeJS.Timeout | null> = useRef<NodeJS.Timeout | null>(null);
  const warningRef: MutableRefObject<NodeJS.Timeout | null> = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
      if (timerRef.current) {
    clearTimeout(timerRef.current);
    timerRef.current = null;
  }
   if (warningRef.current) {
    clearTimeout(warningRef.current);
    warningRef.current = null;
  }
    setIsWarningVisible(false);

    // Warning timer
    warningRef.current = setTimeout(() => {
      setIsWarningVisible(true);
    }, timeout - warningTime);

    // Session timeout
    timerRef.current = setTimeout(() => {
      setIsWarningVisible(false);
      onTimeout();
    }, timeout);
  };

  const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

  useEffect(() => {
    resetTimer();
    for (const event of events) {
      window.addEventListener(event, resetTimer);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (warningRef.current) clearTimeout(warningRef.current);
      for (const event of events) {
        window.removeEventListener(event, resetTimer);
      }
    };
  }, []);

  return { isWarningVisible};
}; useIdleTimer
